import React, { useState, useEffect } from 'react'; // useState aur useEffect add kiya
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { API_BASE_URL } from "./config/config";

// import Loader from './components/Loader';

import Header from './components/Header';
import Footer from './components/Footer';

import Passports from "./components/Passports";
import IDDocuments from "./components/IDDocuments";
import DriverLicenses from "./components/DriverLicenses";
import BankStatements from "./components/bank-statements";
import UtilityBills from "./components/UtilityBills";
import BusinessFormation from "./components/BusinessFormation";
import OtherDocuments from "./components/OtherDocuments";
import ResidentialProxies from "./components/residential-proxies";
import SimCardProxy from "./components/sim-card-proxy";
import DlIdNumbers from "./components/dl-id-numbers";
import MothersMaidenName from "./components/mothers-maiden-name";
import CreditReport from "./components/credit-report";
import CreditScoreLookup from "./components/credit-score";
import SSNDob from "./components/ssn-dob";
import SocialAccounts from "./components/social-accounts";
import FinancialAccounts from "./components/financial-accounts";
import SelfRegisteredccount from "./components/self-reg-acc";
import StreamingAccounts from "./components/streaming-accounts";
import CheckoutPage from "./components/checkout_page";
import ThankYou from './components/thankyou';
import BackgroundReport from './components/background-report';
import DonateUs from './components/donate-us';

// Ye component check karega ke background kab dikhana hai
function BodyClassHandler() {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/') {
            document.body.classList.add('home-body-bg');
        } else {
            document.body.classList.remove('home-body-bg');
        }
    }, [location]);

    return null;
}

function Home() {
        const [homeData, setHomeData] = useState({ heading: '', content: '' });
    
         useEffect(() => {
                const fetchHomeData = async () => {
                    try {
                        const response = await fetch(`${API_BASE_URL}/home-content`, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json', // Yeh line Laravel ke 'expectsJson' ke liye zaroori hai
                                'Content-Type': 'application/json'
                            }
                        });
                        const result = await response.json();
                        
                        if (result.success === 1 && result.data) {
                            setHomeData({
                                heading: result.data.Heading, // DB Column: Heading
                                content: result.data.content  // DB Column: content
                            });
                        }
                    } catch (error) {
                        console.error("Error fetching home content:", error);
                    }
                };
                fetchHomeData();
            }, []);
        
    return (
        <div className="home-hero-section">
            <div className="hero-content">
                <h1 className="main-heading">
                    {/* Welcome to our Marketplace! <br /><span className="brand-name">[1ZONE]</span> */}
                    <h1 className="main-heading" dangerouslySetInnerHTML={{ __html: homeData.heading }} />
                </h1>
                <div className="support-info">
                    <div className="support-info" dangerouslySetInnerHTML={{ __html: homeData.content }} />
                    {/* <h2>Our 24/7 Support Channels</h2>
                    <h3><strong>WhatsApp:</strong> +1 7348741720</h3>
                    <h3><strong>Telegram:</strong> @zone1sp</h3>
                    <h3><strong>Jabber:</strong> 1zone@jabber.cz</h3>
                    <h3><strong>E-Mail:</strong> support@1zone.org</h3> */}
                </div>
            </div>
        </div>
    );
}

function App() {
    
    return (
        <Router>
            <BodyClassHandler />
            <div className="App">
                <Header />
                <main style={{ minHeight: '80vh' }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/passports" element={<Passports />} />
                        <Route path="/id-cards" element={<IDDocuments />} />
                        <Route path="/driver-licenses" element={<DriverLicenses />} />
                        <Route path="/bank-statements" element={<BankStatements />} />
                        <Route path="/utility-bills" element={<UtilityBills />} />
                        <Route path="/business-formation" element={<BusinessFormation />} />
                        <Route path="/other-docs" element={<OtherDocuments />} />
                        <Route path="/residential-proxies" element={<ResidentialProxies />} />
                        <Route path="/sim-card-proxy" element={<SimCardProxy />} />
                        <Route path="/background-report" element={<BackgroundReport />} />
                        <Route path="/dl-id-numbers" element={<DlIdNumbers />} />
                        <Route path="/mothers-maiden-name" element={<MothersMaidenName />} />
                        <Route path="/credit-report" element={<CreditReport />} />
                        <Route path="/credit-score" element={<CreditScoreLookup />} />
                        <Route path="/ssn-dob" element={<SSNDob />} />
                        <Route path="/social-accounts" element={<SocialAccounts />} />
                        <Route path="/financial-accounts" element={<FinancialAccounts />} />
                        <Route path="/self-reg-acc" element={<SelfRegisteredccount />} />
                        <Route path="/streaming-accounts" element={<StreamingAccounts />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/thankyou" element={<ThankYou />} />
                        <Route path="/donate-us" element={<DonateUs />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;